import { Compass } from 'lucide-react';

import type { ReactNode } from 'react';

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <div className="border-line bg-sidebar mx-auto flex max-w-lg flex-col items-center rounded-xl border px-6 py-12 text-center">
      <span className="bg-canvas border-line mb-4 rounded-xl border p-3">
        <Compass className="text-accent size-5" aria-hidden="true" />
      </span>
      <h2 className="text-fg text-lg font-semibold tracking-tight">{title}</h2>
      <p className="text-fg-muted mb-6 mt-2 max-w-sm text-sm leading-6">{description}</p>
      {action}
    </div>
  );
}
